import { render, staticRenderFns } from "./CK_Special.vue?vue&type=template&id=49be811d&"
import script from "./CK_Special.vue?vue&type=script&lang=js&"
export * from "./CK_Special.vue?vue&type=script&lang=js&"
import style0 from "./CK_Special.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports